import React, { useCallback, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Stack } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import noop from 'lodash/noop'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import DialogModal from 'components/generic/modals/dialog-modal'
import PricingFormulaTable from 'components/generic/table/PricingFormulaTable'
import AlertModal from 'components/generic/modals/dialog-modal/AlertModal'
import { getFormulaValues } from 'components/containers/commodities/commoditiesHelpers'

const PricingFormulaModal = ({ open, onSave, onCloseModal, priceEntry, isViewMode, ...restProps }) => {
  const formOptions = { resolver: yupResolver(Yup.object().shape({})) }
  const {
    reset,
    control,
    watch,
    setValue,
    getValues,
    formState: { dirtyFields },
  } = useForm(formOptions)
  const isDirty = !!Object.keys(dirtyFields).length
  const [showCloseModal, setShowCloseModal] = useState(false)
  const { defaultCurrency, defaultYardUm } = useSelector(state => state.settings)

  useEffect(() => {
    if (open) {
      reset()
    }
  }, [open])

  return (
    <div>
      <AlertModal
        open={showCloseModal}
        modalType="close"
        title="Leave This Page"
        question="Are you sure you want to leave this page?"
        description="You have unsaved data on this page and all unsaved data on the ticket will be lost."
        confirmLabel="YES, LEAVE PAGE"
        cancelLabel="GO BACK"
        onClose={() => {
          setShowCloseModal(false)
        }}
        onSubmit={() => {
          setShowCloseModal(false)
          onCloseModal()
        }}
      />
      <DialogModal
        {...restProps}
        open={open}
        buttonTitle={
          isViewMode ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              <EditIcon fontSize="small" />
              Edit
            </div>
          ) : (
            'Save'
          )
        }
        onSave={() => {
          if (!isViewMode) {
            const updatedPriceEntry = getFormulaValues(priceEntry, getValues, defaultCurrency, defaultYardUm)
            onSave(priceEntry.id, updatedPriceEntry)
          } else {
            onSave()
          }
        }}
        onClose={() => (isViewMode || !isDirty ? onCloseModal() : setShowCloseModal(true))}
        sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 1200 } }}
      >
        <Stack sx={{ height: 450 }}>
          <form>
            <PricingFormulaTable
              isViewMode={isViewMode}
              control={control}
              watch={watch}
              setValue={setValue}
              priceEntry={priceEntry}
            />
          </form>
        </Stack>
      </DialogModal>
    </div>
  )
}

PricingFormulaModal.propTypes = {
  ...DialogModal.propTypes,
  open: PropTypes.bool,
  onSave: PropTypes.func,
  onCloseModal: PropTypes.func,
  priceEntry: PropTypes.object,
  isViewMode: PropTypes.bool,
}

PricingFormulaModal.defaultProps = {
  ...DialogModal.defaultProps,
  open: false,
  onSave: noop,
  onCloseModal: noop,
  priceEntry: {},
  isViewMode: false,
}

export default PricingFormulaModal
